@if (this.type() === 'overlay') {
  <rag-overlay-aside
    #overlay
    [skipQueryParam]="true"
    class="text-black"
    >
    <h1 header>Debug-Log</h1>
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </rag-overlay-aside>
}


<div class="d-flex flex-row">
  <div
    id="divider"
    class="bg-light text-center d-flex align-items-center"
    style="border-left: 1px solid rgba(33, 37, 41, 0.25); border-right: 1px solid rgba(33, 37, 41, 0.25); cursor:col-resize"
    >
    <i class="ri-draggable"></i>
  </div>
  <div
    id="content"
    style="width: 30vw;"
    class="d-flex align-items-stretch flex-column"
    >
    <div
      #header
      class="bg-white"
      style="z-index: 100;"
      >
      <div class="row m-0 p-0">
        <div class="col-3 p-0"></div>
        <div class="col-6 p-0">
          <h3 class="text-center">Debug-Log</h3>
        </div>
        <div class="col-3 p-0"> <button class="btn float-end">
          <i
            class="ri-close-line ri-xl text-primary"
            style=" z-index: 150;"
            (click)="this.closed.emit()"
          ></i>
        </button></div>
      </div>
    </div>
    @if (this.type() === 'fullsize') {
      <div
        class="bg-white overflow-scroll px-5 py-3"
        resize="vertical"
        [ngStyle]="{'height': 'calc(100vh - ' + header.clientHeight + 'px)'}"
        >
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </div>
    }
  </div>
</div>

<ng-template #content>
  <ul class="nav nav-tabs mb-2">
    <li class="nav-item">
      <a
        class="nav-link"
        [class.active]="activeTab === 'log'"
        (click)="activeTab = 'log'"
        role="button"
      >Debug-Log</a>
    </li>
    <li class="nav-item">
      <a
        class="nav-link"
        [class.active]="activeTab === 'keyval'"
        (click)="activeTab = 'keyval'"
        role="button"
      >KeyVal-Status</a>
    </li>
  </ul>

  @if (activeTab === 'log') {
    <div>
      @if (this.showOlderLogEntries) {
        <ng-container *ngTemplateOutlet="entryDisplay; context: {$implicit: oldEntries}"></ng-container>
      }
      @if (hasHiddenEntries) {
        <div
          class="row text-muted cursor-pointer"
          (click)="this.showOlderLogEntries = !this.showOlderLogEntries"
          >
          <div class="col">
            <hr>
            </div>
            <div class="col-auto">
              @if (this.showOlderLogEntries) {
                Ältere Einträge ausblenden
              }
              @else {
              Ältere Einträge anzeigen
            }
          </div>
          <div class="col">
            <hr>
            </div>
          </div>
        }
        <ng-container *ngTemplateOutlet="entryDisplay; context: {$implicit: newEntries}"></ng-container>
      </div>
    }

    @if (activeTab === 'keyval') {
      <div>
        <app-bot-debug-keyval></app-bot-debug-keyval>
      </div>
    }
  </ng-template>

  <ng-template
    #entryDisplay
    let-entries
    >
    @for (logEntry of entries; track logEntry; let i = $index) {
      <div>
        @if (logEntry.created.getTime() > initialTimestamp || this.showOlderLogEntries) {
          <ng-container
            class="row"
            >
            <app-debug-entry [logEntry]="logEntry">
            </app-debug-entry>
          </ng-container>
        }
      </div>
    }
  </ng-template>
